import { QuestionCircleFilled } from '@ant-design/icons';
import { Button, Card, Col, Flex, Tooltip, notification } from 'antd';
import { throttle } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Server } from '../../../../../../api/server-index';

const ChangePassword = () => {
  const { t } = useTranslation('settings');
  const [isThrottled, setIsThrottled] = useState(false);

  const sendChangePasswordEmail = throttle(async () => {
    setIsThrottled(false);
    const response = await Server.User.changePassword();
    if (response.status === 200) {
      notification.success({ message: t('password.change.success') });
    }
  }, 180000);

  const handleChangeClick = () => {
    if (isThrottled) {
      notification.warning({ message: t('password.change.limit') });
      return;
    }

    setIsThrottled(true);
    sendChangePasswordEmail();
  };

  return (
    <Col xl={12} lg={12} md={24} sm={24} xs={24}>
      <Card className='shadow-sm'>
        <Flex gap={8}>
          <h4>{t('password.change.title')}</h4>
          <Tooltip title={t('password.change.tooltip')}>
            <QuestionCircleFilled />
          </Tooltip>
        </Flex>
        <Flex justify='end'>
          <Button onClick={() => handleChangeClick()} type='primary' ghost>
            {t('password.change.send')}
          </Button>
        </Flex>
      </Card>
    </Col>
  );
};

export default ChangePassword;
